import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProduct } from '../../../admin/actions/productActions'
import ProductDetaillView from '../../../containers/MarketPlace/ProductDetaill/ProductDetaill'



const ProductDetaill = ({match}) => {

    const dispatch = useDispatch()
    const { bag } = useSelector(state => state.marketPlace)

    const {product} = useSelector(state=>state.productsList)
    useEffect(() => {
        dispatch(getProduct(match.params.productId))
    
      return () => {
        
      }
    }, [match.params.productId])
  
  return (
    <ProductDetaillView product={product} bag={bag} />
  )
}

export default ProductDetaill